import {ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractPasswordInput} from "../abstract-password-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopPasswordInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-password-input",
    styleUrls: ["./pop-password-input.component.scss"],
    templateUrl: "./pop-password-input.component.html"
})
export class FUIPopPasswordInputComponent extends FUIAbstractPasswordInput {

    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    public override click(): void {
        this.focus();
    }
}
